<template>
  <div class="checkedReportDetailBox" id="pdfDom">
    <div class="nav">
      <van-nav-bar
        title="检查报告"
        left-arrow
        left-text="返回"
        :fixed="true"
        @click-left="$router.go(-1)"
      />
      <div class="top"></div>
    </div>
    <!-- <canvas canvas-id="playbillCanvas"></canvas> -->
    <div id="all">
      <div class="checkedReportBox">
        <div class="checkedHeader">
          <div class="hospitalIcon"></div>

          <div class="hospitalTitle">永仁县人民医院检查报告单</div>
        </div>
        <div class="checkedBody">
          <div class="row">
            <div class="column">姓 名</div>
            <div class="column1">
                {{this.$route.query.item.applyName }}
                </div>
          </div>
          <div class="row">
            <div class="column">科 室</div>
            <div class="column1">
                {{this.$route.query.item.applyDeptName }}
                </div>
           
          </div>
		 
          <div class="rowBottom">
            <div>
              检查项目:
              <div style="color: #666">
                  {{ this.$route.query.item.projectName }}
                  </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          font-size: 12px;
          width: 95%;
          height: 30px;
          margin: 0 auto;
          line-height: 30px;
        "
      >
        检查所见:
      </div>
      <div class="checkedContent">
        {{this.$route.query.item.inspectView }}
      </div>
      <div
        style="
          font-size: 12px;
          width: 95%;
          height: 30px;
          margin: 0 auto;
          line-height: 30px;
        "
      >
        检查意见:
      </div>
      <div class="checkedContent">
        {{ this.$route.query.item.inspectDiagnose }}
      </div>

     
	  <div class="checkedBottom">
        <div>此报告仅供临床参考,不做证明之用!</div>
      </div>
      <div class="checkedBottom" style="margin-top: 0; border: none">
        
        <div>报告日期:
            {{ this.$route.query.item.reportDate }}
            </div>
      </div>
    </div>

    <!-- <div class="checkedBtn">
			<div @click="getPdf('#all')">下载报告</div>
		</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "报告单",
      htmlTitle: "检查报告",
      inReportID: "",
      inReportNum: "",
      inReportID: "",
      pacsInfo: {},
    };
  },
  created() {
  },
  methods: {
    
  },
};
</script>

<style lang="scss">
.checkedReportDetailBox {
  width: 100%;
  position: relative;
  .top {
    height: 6vh;
    width: 100%;
  }
  .hospitalTitle {
    height: 3vh;
    box-sizing: border-box;
    line-height: 6vh;
    text-align: center;
    font-size: 20px;
    color: #000;
  }

  #all {
    .checkedReportBox {
      width: 95%;
      margin: 20px auto 0 auto;
      border: 2px solid #ccc;

      .checkedHeader {
        width: 100%;
        height: 8vh;
        display: flex;
        border-bottom: 1px solid #333;
        box-sizing: border-box;

        .hospitalIcon {
          width: 8vh;
          height: 100vh;
        }

        .checkedHeaderTitle {
          flex: 1;
          height: 100%;
          border-left: 2px solid #ccc;
          .hospitalTitle {
            height: 3vh;
            border-bottom: 2px solid #ccc;
            box-sizing: border-box;
            line-height: 3vh;
            text-align: center;
            font-size: 20px;
            color: #000;
          }

          .checkedTitle {
            height: 4vh;
            line-height: 4vh;
            text-align: center;
            font-size: 15px;
            color: #f40;
          }
        }
      }

      .checkedBody {
        width: 100%;

        .row {
          width: 100%;
          border-bottom: 2px solid #ccc;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .column {
            width: 11vw;
            height: 6vh;
            border-right: 2px solid #ccc;
            box-sizing: border-box;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #666;
          }

          .column1 {
            flex: 1;
            height: 6vh;
            border-right: 2px solid #ccc;
            box-sizing: border-box;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .rowBottom {
          font-size: 14px;
        }
      }
    }

    .checkedContent {
      width: 95%;
      margin: 0 auto;
      border: 2px solid #ccc;
      font-size: 14px;
      color: #333;
      text-indent: 25px;
    }

    .checkedBottom {
      width: 95%;
      margin: 50px auto 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      border-bottom: 1px solid #333;
    }
  }

  .checkedBtn {
    width: 100%;
    height: 8vh;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #333;
    background-color: #fff;

    div:nth-child(1) {
      width: 95%;
      height: 6vh;
      border-radius: 40px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      background-color: #5b8df6;
    }
  }
}
</style>
